import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useState } from "react";

import { Alert, Button, Card } from "../components/ui";
import { describeError } from "../features/auth/errors";
import { requireAuth, useInvalidateMe } from "../features/auth/session";
import { useT } from "../i18n/I18nProvider";
import { authClient } from "../lib/auth-client";

export const Route = createFileRoute("/invitations/$id")({
  beforeLoad: ({ context, location }) => requireAuth(context.queryClient, location.href),
  component: InvitationPage,
});

function InvitationPage() {
  const t = useT();
  const navigate = useNavigate();
  const invalidateMe = useInvalidateMe();
  const { id } = Route.useParams();
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  const accept = async () => {
    setBusy(true);
    setError(null);
    const result = await authClient.organization.acceptInvitation({ invitationId: id });
    setBusy(false);
    if (result.error) {
      setError(
        result.error.status === 400 || result.error.status === 404
          ? t("invitations.error")
          : describeError(t, result.error),
      );
      return;
    }
    await invalidateMe();
    await navigate({ to: "/app/organizations" });
  };

  return (
    <main className="mx-auto w-full max-w-md px-4 py-10">
      <Card title={t("invitations.title")}>
        <p>{t("invitations.body")}</p>
        {error ? <Alert kind="error">{error}</Alert> : null}
        <Button busy={busy} onClick={() => void accept()}>
          {t("invitations.accept")}
        </Button>
      </Card>
    </main>
  );
}
